/*
 * @Author: dali
 * @Date: 2022-09-28 18:01:30
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-08-04 11:16:57
 * @FilePath: \gerlun-react-website\src\pages\product-center\serve\index.jsx
 * @Description:
 */
import React, { useState, useEffect, useRef } from 'react'
import styles from './serve.scss'
import product_1 from '../../../common/images/product/product-1.jpg'
import yd_product1 from '../../../common/images/product/yd-product1.png'
import solution from '../../../common/images/solution/solution.png'
import User from '@/modules/user'
import { useNavigate } from 'react-router-dom'
import OrderSkeletons from './OrderSkeletons'

const Serve = (props) => {
  const navigate = useNavigate()
  const user = new User()
  const [tableData, setData] = useState([])
  const scrollTop = useRef(0)
  const form = {
    pageSize: 7,
    pageNum: 1,
    articleName: '',
    releaseColumn: '产品中心',
    releaseColumnId: ''
  }
  const getData = () => {
    user.getArticleList(form)
      .then(res => {
        res.result.forEach(item => {
          // 取切割后的第一个元素，作为副标题值。如：财税服务机构\n客户运营/发票采集/智能记账\n个税申报/国税全税种申报
          item.digest = item.digest && item.digest.includes('\\n') ? item.digest.split('\\n')[0] : item.digest
        })
        const sortList = ['标准企业版', '高级企业版', '普及版', '标准代账版', '专业代账版', '高级代账版', '云报销']
        res.result.sort((a, b) => {
          return sortList.indexOf(a.articleName) - sortList.indexOf(b.articleName)
        })
        setData(res.result)
      })
      .catch((res) => {
        setData([])
        console.log(res)
      })
  }
  const handleScroll = (event) => {
    // 滚动的高度
    scrollTop.current = event.srcElement ? event.srcElement.documentElement.scrollTop : 0
  }
  useEffect(()=>{
    getData()
    const top = sessionStorage.getItem('ServeScrollTop')
    if (top > 0) {
      window.scrollTo({
        top
      })
      sessionStorage.setItem('ServeScrollTop', 0)
    }
    window.addEventListener('scroll', handleScroll)
  }, [])

  const handleNavigate = (path) => {
    sessionStorage.setItem('ServeScrollTop', scrollTop.current)
    window.scrollTo({
      top: 0
    })
    navigate(path)
  }
  return <section className={styles['serve']}>
    <div className={styles['serve-contnet']}>
      <div className={styles['product_1']}>
        <img src={product_1} alt='product_1' className={styles['product']} />
        <img src={yd_product1} alt='yd_product1' className={styles['yd_product1']} />
        <div>
          <h2>概而论云记账</h2>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['introduce']}>
        <img src={solution} alt='solution' className={styles['solution']} />
        <div className={styles['introduce-serve']}>产品服务<h2>，解决不同的场景应用</h2></div>
        <p className={styles['introduce-p']}>点击了解应用场景，选择适合自己的产品</p>
        <ul className={styles['standard']}>
          { tableData && tableData.length > 0 ? tableData.map(val => {
            return (
              <li onClick={() => handleNavigate(`/standard/${val.id}`)} key={val.id}>
                <a href='/#' onClick={(e) => e.preventDefault()}>
                  <div className={styles['standard_img']}>
                    <img src={val.thumbnails[0].url} alt='product_2' />
                  </div>
                  <p className={styles['standard_p']}>{val.articleName}</p>
                  <span className={styles['standard_span']}>{val.digest}</span>
                </a>
              </li>
            )
          }) : <OrderSkeletons />}
        </ul>
      </div>
    </div>
  </section>
}

export default Serve
